/*工具函数*/
export const getDataType = value => {
  //返回数据类型 [] => array , 0 => number,  "a" => string, {} => object 等;
  return Object.prototype.toString.call(value).slice(8, -1).toLowerCase()
};

export const baseBinary2File = (binary, fileName) => {
  // base64转file文件
  let arr = binary.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], fileName, {type: mime});
};

export const getUrlParams = (url, key) => {
  let search = url && url.split("?")[1];
  var theRequest = {};
  let query = search && search.split("&");
  for (let i = 0; i < query.length; i++) {
    theRequest[query[i].split("=")[0]] = decodeURI(query[i].split("=")[1]);
  }
  return key ? theRequest[key] : theRequest;
};

export const NumberToChinese = (num) => {
  let chnNumChar = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
  let chnUnitSection = ["", "万", "亿", "万亿", "亿亿"];
  let chnUnitChar = ["", "十", "百", "千"];

  let unitPos = 0;
  let strIns = '',
      chnStr = '';
  let needZero = false;

  /**
   * @return {string}
   */
  function SectionToChinese(section) {
    let strIns = '',
        chnStr = '';
    let unitPos = 0;
    let zero = true;
    while (section > 0) {
      let v = section % 10;
      if (v === 0) {
        if (!zero) {
          zero = true;
          chnStr = chnNumChar[v] + chnStr;
        }
      } else {
        zero = false;
        strIns = chnNumChar[v];
        strIns += chnUnitChar[unitPos];
        chnStr = strIns + chnStr;
      }
      unitPos++;
      section = Math.floor(section / 10);
    }
    return chnStr;
  }

  if (num === 0) {
    return chnNumChar[0];
  }

  while (num > 0) {
    let section = num % 10000;
    if (needZero) {
      chnStr = chnNumChar[0] + chnStr;
    }
    strIns = SectionToChinese(section);
    strIns += (section !== 0) ? chnUnitSection[unitPos] : chnUnitSection[0];
    chnStr = strIns + chnStr;
    needZero = (section < 1000) && (section > 0);
    num = Math.floor(num / 10000);
    unitPos++;
  }

  return chnStr;
};


